(function () {
    "use strict";

    angular.module("app").controller("CisScreeningResultsController", CisScreeningResultsController);

    CisScreeningResultsController.$inject = ["$scope", "controllerDecorator", "$timeout", "cisScreening", "cisRequest"];
    function CisScreeningResultsController($scope, controllerDecorator, $timeout, cisScreening, cisRequest) {
        const vm = this;
        controllerDecorator.Decorate(vm, []);

        vm.AuditResult = {
            Add: (request) => $scope.AuditResult = { request: request, },
            CanAdd: (request) => request && request.Screening.Status === 30
        };

        vm.AuditResult.Options = {
            templateUrl: "@/cis/audit-result.template.html",
            scope: $scope,
            onEscape: true,
            title: vm.getTranslation("InspectionResult_DialogTitle"),
            buttons: {
                ok: {
                    label: vm.getTranslation("Button_Confirm"),
                    className: "btn-primary",
                    callback: onSubmitAuditResult,
                },
                cancel: {
                    label: vm.getTranslation("Button_Cancel"),
                    className: "btn-default"
                }
            },
            onHidden: () => { $scope.AuditResult = null; },
            size: "large"
        };

        vm.CisTypeChecked = cisTypeChecked;

        vm.Save = save;

        vm.Initialize = function (form, request) {
            form.$setValidity("Types", request.Types.length > 0);
        };

        $scope.ShouldConfirmDate = () => {
            if ($scope.AuditResult?.IsApproved !== true)
                return false;

            if (!$scope.AuditResult?.ApprovedUntil)
                return false;

            return habilCommon.dateUtils.isDateWithinMonths(new Date($scope.AuditResult.ApprovedUntil), 6);
        };

        function save(request, form) {
            vm.SetLoadingState(true);
            cisRequest.SubmitCisTypeInfo(
                { RequestId: request.PublicId, Types: request.Types, Explanation: request.TypeExplanation, },
                () => {
                    form.$setPristine();
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function onSubmitAuditResult() {
            if (!$scope.auditResultForm.$valid) {
                return false;
            }

            const model = $scope.AuditResult;

            if ($scope.ShouldConfirmDate() && model.ConfirmApprovedUntil !== true) {
                $timeout(() => model.HasError = true);
                return false;
            }

            const request = model.request;

            // Clear the default date when the inspection does not result in approval
            if (model.ApprovalType == 0)
                model.ApprovedUntil = null;

            vm.SetLoadingState(true);
            cisScreening.RegisterAudit(
                { RequestId: request.PublicId, Result: model },
                r => {
                    request.Screening = r.data.Screening;
                    request.AuditResults.push(r.data.AuditResult);
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
            return true;
        }

        function cisTypeChecked(request, cisType, form) {
            const currentIndex = request.Types.indexOf(cisType);

            if (currentIndex === -1) {
                request.Types.push(cisType);
            }
            else {
                request.Types.splice(currentIndex, 1);
            }

            form.$setValidity("Types", request.Types.length > 0);
            form.$setDirty();
        }
    }
})();
